export default function login() {
  // It might be worth doing a middleware here at some point,
  // but that’s not for sure.
  // if (store.getters["auth/token"]) {
  //   return { path: "/" };
  // }

  return null;
}
